// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"63226cf8","134":"a706ae44","243":"fe07634c","297":"5195e7bf","575":"617509bb","618":"23fc4bf6","704":"794eeae7"}[chunkId] + ".chunk.js";
};